import { render, staticRenderFns } from "./MultipleLAttributeEditorComponent.vue?vue&type=template&id=4afedbe7&scoped=true"
import script from "./MultipleLAttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./MultipleLAttributeEditorComponent.vue?vue&type=script&lang=js"
import style0 from "./MultipleLAttributeEditorComponent.vue?vue&type=style&index=0&id=4afedbe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afedbe7",
  null
  
)

export default component.exports